export default "__VITE_ASSET__6TtlhY8R__"